module.exports = "<modal-gallery *ngIf=\"imgs&&imgs.length>0\"\r\n               [modalImages]=\"imgs\"\r\n               [downloadable]=\"false\"\r\n               [slideConfig]=\"{infinite: false}\"\r\n                ></modal-gallery>\r\n<span *ngIf=\"!imgs||imgs.length<=0\">无</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/nbinput/nbinput-gallery.component.html
// module id = 185
// module chunks = 0 1